import React from 'react';
import PropTypes from 'prop-types';

import SubmitButton from '../SubmitButton';

const FacebookLoginButton = ({ text, handler }) => {

  return (
    <SubmitButton text={text} handler={handler} variant="facebookLogin" />
  );
};

FacebookLoginButton.defaultProps = {
  text: 'Continue with Apple',
  handler: () => {},
};

FacebookLoginButton.propTypes = {
  text: PropTypes.string,
  handler: PropTypes.func
};

export default FacebookLoginButton;
